export default __webpack_public_path__ + "static/media/dashboard.24c96cf7.png";